module.exports = __webpack_public_path__ + "fonts/IRANYekanWebLight.0dbeec3.woff";